<template>
  <div class="gradient-container"></div>
</template>

<script>
export default {
  name: "BottomGradient",
  components: {},
};
</script>

<style scoped>
.gradient-container {
  width: 100vw;
  height: 250px;
  position: fixed;
  bottom: 0;
  left: 0;
  background: linear-gradient(0deg,rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0) 100%);
  z-index: 100000;
  pointer-events: none;
}

@media screen and (max-width: 768px) {
  .gradient-container {
    height: 100px;
  }
}
</style>
